function wrapWords(element) {
  if (!element) return null;
  
  if (element.querySelectorAll('.aomai-big-text-word').length > 0) {
    return element.querySelectorAll('.aomai-big-text-word');
  }
  
  if (!element.textContent || !element.textContent.trim()) {
    return null;
  }
  
  const text = element.textContent;
  const words = text.split(/(\s+)/);
  const fragment = document.createDocumentFragment();
  
  words.forEach(word => {
    if (word.trim()) {
      const span = document.createElement('span');
      span.className = 'aomai-big-text-word';
      span.style.display = 'inline-block';
      span.textContent = word;
      fragment.appendChild(span);
    } else if (word) {
      fragment.appendChild(document.createTextNode(word));
    }
  });
  
  element.innerHTML = '';
  element.appendChild(fragment);
  
  return element.querySelectorAll('.aomai-big-text-word');
}

function wrapChars(element) {
  if (!element) return null;
  
  if (element.querySelectorAll('.aomai-big-text-char').length > 0) {
    return element.querySelectorAll('.aomai-big-text-char');
  }
  
  if (!element.textContent || !element.textContent.trim()) {
    return null;
  }
  
  const text = element.textContent;
  const words = text.split(/(\s+)/);
  const fragment = document.createDocumentFragment();
  
  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    
    if (!word) continue;
    
    if (word.trim()) {
      const wordWrapper = document.createElement('span');
      wordWrapper.style.display = 'inline';
      wordWrapper.style.whiteSpace = 'nowrap';
      
      const wordChars = word.split('');
      wordChars.forEach(char => {
        const span = document.createElement('span');
        span.className = 'aomai-big-text-char';
        span.style.display = 'inline-block';
        span.textContent = char;
        wordWrapper.appendChild(span);
      });
      
      fragment.appendChild(wordWrapper);
    } else {
      if (i > 0 && i < words.length - 1 && words[i - 1] && words[i + 1] && words[i - 1].trim() && words[i + 1].trim()) {
        const spaceSpan = document.createElement('span');
        spaceSpan.className = 'aomai-big-text-char';
        spaceSpan.style.display = 'inline-block';
        spaceSpan.style.width = '0.25em';
        fragment.appendChild(spaceSpan);
      }
    }
  }
  
  element.innerHTML = '';
  element.appendChild(fragment);
  
  return element.querySelectorAll('.aomai-big-text-char');
}

function resetBigTextAnimationStates(container, animationType = 'word') {
  const title = container.querySelector('.aomai-impact-text-container-title');
  const textUp = container.querySelector('.aomai-impact-text-container-text-up');
  const textDown = container.querySelector('.aomai-impact-text-container-text-down');

  if (title) {
    if (animationType === 'char') {
      const titleChars = wrapChars(title);
      if (titleChars && titleChars.length > 0) {
        titleChars.forEach(char => {
          gsap.set(char, { 
            opacity: 0, 
            y: 40
          });
        });
      } else {
        gsap.set(title, { 
          opacity: 0, 
          y: 40
        });
      }
    } else {
      const titleWords = wrapWords(title);
      if (titleWords && titleWords.length > 0) {
        titleWords.forEach(word => {
          gsap.set(word, { 
            opacity: 0, 
            y: 40
          });
        });
      } else {
        gsap.set(title, { 
          opacity: 0, 
          y: 40
        });
      }
    }
  }
  if (textUp) {
    gsap.set(textUp, { 
      opacity: 0, 
      y: 15 
    });
  }
  if (textDown) {
    gsap.set(textDown, { 
      opacity: 0, 
      y: 15 
    });
  }
}

function createBigTextAnimation(container, triggerElement) {
  const title = container.querySelector('.aomai-impact-text-container-title');
  const textUp = container.querySelector('.aomai-impact-text-container-text-up');
  const textDown = container.querySelector('.aomai-impact-text-container-text-down');

  if (!title) {
    return null;
  }

  const animationType = container.dataset.animationType || 'word';

  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: triggerElement,
      start: 'top 60%',
      end: 'top 20%',
      scrub: 0.5,
      invalidateOnRefresh: true
    }
  });

  timeline.addLabel('titleStart');

  if (title) {
    if (animationType === 'char') {
      const titleChars = wrapChars(title);
      if (titleChars && titleChars.length > 0) {
        const charDelay = 0.03;
        titleChars.forEach((char, index) => {
          timeline.fromTo(char,
            {
              opacity: 0,
              y: 40
            },
            {
              opacity: 1,
              y: 0,
              duration: 0.4,
              ease: 'power2.out'
            },
            `titleStart+=${index * charDelay}`
          );
        });
      } else {
        timeline.fromTo(title,
          {
            opacity: 0,
            y: 40
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out'
          },
          'titleStart'
        );
      }
    } else {
      const titleWords = wrapWords(title);
      if (titleWords && titleWords.length > 0) {
        const wordDelay = 0.08;
        titleWords.forEach((word, index) => {
          timeline.fromTo(word,
            {
              opacity: 0,
              y: 40
            },
            {
              opacity: 1,
              y: 0,
              duration: 0.5,
              ease: 'power2.out'
            },
            `titleStart+=${index * wordDelay}`
          );
        });
      } else {
        timeline.fromTo(title,
          {
            opacity: 0,
            y: 40
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out'
          },
          'titleStart'
        );
      }
    }
  }

  let titleDuration;
  if (animationType === 'char') {
    const titleChars = title.querySelectorAll('.aomai-big-text-char');
    titleDuration = titleChars && titleChars.length > 0 
      ? (titleChars.length - 1) * 0.03 + 0.4 
      : 0.8;
  } else {
    const titleWords = title.querySelectorAll('.aomai-big-text-word');
    titleDuration = titleWords && titleWords.length > 0 
      ? (titleWords.length - 1) * 0.08 + 0.5 
      : 0.8;
  }

  timeline.addLabel('textsStart', `titleStart+=${titleDuration * 0.6}`);

  if (textUp) {
    timeline.fromTo(textUp,
      {
        opacity: 0,
        y: 15
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.4,
        ease: 'power2.out'
      },
      'textsStart'
    );
  }

  if (textDown) {
    timeline.fromTo(textDown,
      {
        opacity: 0,
        y: 15
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.4,
        ease: 'power2.out'
      },
      'textsStart+=0.15'
    );
  }

  return timeline;
}

function initializeBigTextAnimations() {
  if (typeof gsap === 'undefined') {
    console.warn('GSAP não carregado. Aguardando...');
    setTimeout(initializeBigTextAnimations, 100);
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  if (Shopify && Shopify.designMode) {
    return;
  }

  if (typeof ScrollTrigger === 'undefined') {
    console.warn('ScrollTrigger não carregado. Aguardando...');
    setTimeout(initializeBigTextAnimations, 100);
    return;
  }

  if (gsap.registerPlugin) {
    gsap.registerPlugin(ScrollTrigger);
  }

  const containers = document.querySelectorAll('.aomai-impact-text-container');
  
  containers.forEach((container) => {
    const section = container.closest('.shopify-section');
    if (!section) return;

    const existingTriggers = ScrollTrigger.getAll().filter(trigger => {
      if (trigger.vars && trigger.vars.trigger) {
        const triggerEl = typeof trigger.vars.trigger === 'string' 
          ? document.querySelector(trigger.vars.trigger)
          : trigger.vars.trigger;
        return triggerEl === section;
      }
      return false;
    });

    existingTriggers.forEach(trigger => trigger.kill());

    const animationType = container.dataset.animationType || 'word';
    resetBigTextAnimationStates(container, animationType);
    createBigTextAnimation(container, section);
  });

  ScrollTrigger.refresh();
}

function waitForGSAPAndScrollTrigger(callback, maxAttempts = 50) {
  let attempts = 0;
  
  function check() {
    attempts++;
    
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      if (gsap.registerPlugin) {
        gsap.registerPlugin(ScrollTrigger);
      }
      callback();
    } else if (attempts < maxAttempts) {
      setTimeout(check, 100);
    } else {
      console.warn('GSAP ou ScrollTrigger não carregados após múltiplas tentativas');
    }
  }
  
  check();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    waitForGSAPAndScrollTrigger(initializeBigTextAnimations);
  });
} else {
  waitForGSAPAndScrollTrigger(initializeBigTextAnimations);
}

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId && document.querySelector(`#shopify-section-${event.detail.sectionId} .aomai-impact-text-container`)) {
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.getAll().forEach(trigger => {
          if (trigger.vars && trigger.vars.trigger) {
            const triggerEl = typeof trigger.vars.trigger === 'string' 
              ? document.querySelector(trigger.vars.trigger)
              : trigger.vars.trigger;
            if (triggerEl && triggerEl.closest(`#shopify-section-${event.detail.sectionId}`)) {
              trigger.kill();
            }
          }
        });
      }
      setTimeout(initializeBigTextAnimations, 100);
    }
  });
  
  document.addEventListener('shopify:section:unload', function(event) {
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.getAll().forEach(trigger => {
        if (trigger.vars && trigger.vars.trigger) {
          const triggerEl = typeof trigger.vars.trigger === 'string' 
            ? document.querySelector(trigger.vars.trigger)
            : trigger.vars.trigger;
          if (triggerEl && triggerEl.closest(`#shopify-section-${event.detail.sectionId}`)) {
            trigger.kill();
          }
        }
      });
    }
  });
}
